// Import các trang của bottom nav và nút tài khoản trên TopBar, dùng chung cho React.lazy (App.js) và tải trước.
// Chuyển trang bằng View Transitions đứng hình trang cũ tới khi trang mới commit, nên chunk chưa tải thì bấm tab
// thấy tab đã chọn nhưng trang còn đứng một lúc. Tải trước chunk lúc rảnh và khi chạm tab để bỏ khoảng chờ đó.
export const tabPageImports = {
  '/': () => import('../pages/Home/Home'),
  '/ma-giam-gia': () => import('../pages/Coupons/Coupons'),
  '/orders': () => import('../pages/Orders/Orders'),
  '/flashsale': () => import('../pages/FlashSale/FlashSale'),
  '/payments': () => import('../pages/Payments/Payments'),
  '/account': () => import('../pages/Account/Account'),
};

// Các trang thuộc khu tài khoản: sáng nút tài khoản trên TopBar, không sáng tab nào ở thanh đáy
export const ACCOUNT_PATHS = /^\/(account|lost-order-search)/;

const started = new Set();

export const preloadTabPage = (path) => {
  const load = tabPageImports[path];
  if (!load || started.has(path)) return;
  started.add(path);
  // Lỗi mạng thì cho tải lại ở lần sau (React.lazy vẫn tự import khi vào trang)
  load().catch(() => started.delete(path));
};

export const preloadAllTabPages = () => {
  Object.keys(tabPageImports).forEach(preloadTabPage);
};
